import { Environment } from './environment.model';

export const environment: Environment = {
    fayeUrl: 'https://ws.baresto.preprod.spiriit.tech',
    name: 'staging',
    tokenCookieName: 'JWT',
    sentryDsn: 'https://680108615be8484a05a16a334975efa7@sentry.infra.ik.spiriit.cloud/35',
    sentryRelease: '2026.11.04',
    analytics: 'GTM-WMNRMLK',
    markerIo: {
        project: '671f9f367a3b33b4b92d8582',
    },
    release: '2026.11.04',
    barestoUser: {
        establishment: 277,
        username: 'demobaresto',
    },
};
